module.exports = __webpack_public_path__ + "img/butterfly_half.9699a3ce.svg";